const style1 = {
  backgroundColor: '#4F81BD',
  color: '#fff',
  minWidth: '150px',
};
const style2 = {
  backgroundColor: '#00B050',
  color: '#fff',
};

export const HeaderStandard = [
  [
    { text: 'S.No.', style: style1 },
    { text: 'Type', style: style1 },
    { text: 'Check Points', style: style1 },
    { text: 'Method of Checking', style: style1 },
    { text: 'CTX', style: style1 },
    { text: 'DESCRIPTION', style: { ...style1, minWidth: '300px' } },
    { text: 'Result (OK/NG)', style: style1 },
    { text: 'Action Taken on Non-Conformity', style: style1 },
    { text: 'Remarks', style: style1 },
    { text: 'Action', style: { ...style1, backgroundColor: '#c92a2a' } },
  ],
];

export const listConstant = {
  childHeader: 'Annual Preventive Checksheet list',
  addButtonLable: 'New Checksheet',
};

export const headerConstant = {
  tableCompHeadTitle: 'Annual Preventive CHECKSHEET ',
};

export const apiConstant = {
  get: 'annualPreventivePlanMasterNewChecklistRoute',
  getById: 'annualPreventivePlanMasterNewChecklistRoute',
  post: 'annualPreventivePlanMasterNewChecklistRoute',
  update: 'annualPreventivePlanMasterNewChecklistRoute',
  delete: 'annualPreventivePlanMasterNewChecklistRoute',
  upload: 'annualPreventivePlanMasterNewChecklistRoute/uploadFile',
  forAutoComplete: 'machineRoutes/machine/ForAutocomplete',
};

export const tilesConstant = {
  childHeaderText: 'Annual Preventive',
};

export const navigationConstant = {
  createEditChecklist: '/admin/annualPreventivePlanNewMasterChecklistCreate',
};
